import background from "../assets/Background.webp";
import FAQ from "../assets/FAQMark.svg";
import shadown from "../assets/Shadown.webp";
import ArrowConversion from "../assets/arrow-conversion.svg";
import BgLine from "../assets/bgLine.svg";
import Hammer from "../assets/block-menu/hammer.svg";
import Move from "../assets/block-menu/move.svg";
import QuestionMark from "../assets/block-menu/question.svg";
import token_house from "../assets/buildings/token-house.png";
import darkBgBlock from "../assets/darkBgBlock.webp";
import HandTutorial from "../assets/hand-tutorial.webp";
import bag from "../assets/lab/bag.webp";
import bg from "../assets/lab/bg.webp";
import bread from "../assets/lab/bread.webp";
import cheese from "../assets/lab/cheese.webp";
import coin from "../assets/lab/coin.webp";
import caw from "../assets/lab/cow.webp";
import iron from "../assets/lab/iron.webp";
import key from "../assets/lab/key.webp";
import milk from "../assets/lab/milk.webp";
import wheat from "../assets/lab/wheat.webp";
import labWood from "../assets/lab/wood.webp";
import lightBgBlock from "../assets/lightBgBlock.webp";
import MockAvatar from "../assets/mockAvatar.webp";
import QrCode from "../assets/qrcode.svg";
import rebuildShip from "../assets/sea/Rebuilt-ship.webp";
import ruinedShip from "../assets/sea/Ruined-ship.webp";
import TCoin from "../assets/tcoin.webp";
import token from "../assets/tutorial-person/tv-token-character.webp";
import defaultPerson from "../assets/tutorial-person/wood-worker-character.webp";
import XClose from "../assets/x.svg";

const images = {
  MockAvatar,
  background,
  shadown,
  lightBgBlock,
  darkBgBlock,

  sea: {
    rebuildShip,
    ruinedShip,
  },

  icons: {
    FAQ,
    TCoin,
    QrCode,
    HandTutorial,
    Hammer,
    Move,
    QuestionMark,
    XClose,
    BgLine,
    ArrowConversion,
  },
  buildings: {
    token_house,
  },
  tutorialPerson: {
    token,
    default: defaultPerson,
  },
  lab: {
    caw,
    bag,
    key,
    bg,
    coin,
    milk,
    bread,
    wheat,
    token: TCoin,
    cheese,
    iron,
    wood: labWood,
  },
};

export default images;
